import * as React from 'react';
import invariant from 'react-utils/invariant';
import FormattedMessage from 'I18n/components/FormattedMessage';
import StyledFilterContainer from 'flow-doctor-lib/components/filters/StyledFilterContainer';
import ListNameLabel from 'flow-doctor-lib/components/common/ListNameLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const withListTypeCheck = WrappedComponent => {
  return props => {
    invariant(props.associatedList.listTypes.length === 1, `List event triggers with multiple types must be deconstructed before being displayed. Found ${props.associatedList.listTypes}`);
    const listType = props.associatedList.listTypes[0];

    // We need to use a runtime invariant here since the types for associatedList aren't based on a discriminated union
    invariant(listType === 'ADDED_TO_LIST_TRIGGER' || listType === 'REMOVED_FROM_LIST_TRIGGER', `List event triggers can only be of type ADDED_TO_LIST_TRIGGER or REMOVED_FROM_LIST_TRIGGER, but was ${listType}`);
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props));
  };
};
const ListEventTriggerRenderer = ({
  associatedList
}) => {
  return /*#__PURE__*/_jsxs(StyledFilterContainer, {
    children: [/*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `flow-doctor-lib.listEventTriggers.types.${associatedList.listTypes[0]}`
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(ListNameLabel, {
      portalId: associatedList.portalId,
      listId: associatedList.listId,
      showId: getIsInternal()
    })]
  });
};
export default withListTypeCheck(ListEventTriggerRenderer);